(function () {
  'use strict';

  function initTimeline(root) {
    var track = root.querySelector('[data-st-fill]');
    var trackWrap = root.querySelector('.st-track');
    var items = root.querySelectorAll('[data-st-item]');

    if (!track || !trackWrap) return;

    var ticking = false;

    function update() {
      ticking = false;

      var trackRect = trackWrap.getBoundingClientRect();
      var referenceY = window.innerHeight * 0.5;

      var progress = referenceY - trackRect.top;
      progress = Math.max(0, Math.min(progress, trackRect.height));
      track.style.height = progress + 'px';

      items.forEach(function (item) {
        var checkpoint = item.querySelector('[data-st-checkpoint]');
        if (!checkpoint) return;

        var cpRect = checkpoint.getBoundingClientRect();
        var cpCenter = cpRect.top + cpRect.height / 2;

        if (referenceY >= cpCenter) {
          item.classList.add('is-complete');
        } else {
          item.classList.remove('is-complete');
        }
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate);

    update();
  }

  function init() {
    var timelines = document.querySelectorAll('[data-st-timeline]');
    timelines.forEach(function (el) {
      initTimeline(el.closest('.st'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();